import { Card, Space, Table, Input, Button, Flex, Row, Col, Statistic, Divider } from 'antd';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';
import CustomerInfoPage from 'pages/customer/info';
import CustomerInfoEdit from 'components/customer/CustomerInfoEdit';
import _ from 'lodash';

const { Search } = Input;

const CustomerListDesktop = ({ viewModel }) => {
  const {
    data,
    filter,
    clickPhone,
    showCustomerInfo,
    showAddCustomer,
    setFilterValue,
    onSearch,
    showCustomer,
    refreshList,
    onNavigateOrder,
    onAddCustomer,
    onCloseCustomerInfo,
    onCloseAddCustomer,
  } = viewModel;

  const columns = [
    {
      title: 'Khách hàng',
      render: (record) => (
        <Space direction='vertical'>
          <Button
            type='text'
            onClick={() => showCustomer(record.id)}
          >
            {record.phone}
          </Button>
          <div>{record.full_name}</div>
        </Space>
      ),
    },
    {
      title: 'Điểm tích luỹ',
      sorter: (a, b) => (a.loyalty_point?.current ?? 0) - (b.loyalty_point?.current ?? 0),
      render: (record) => (
        <Space direction='vertical'>
          <div>{formatCurrency(record.loyalty_point?.current)}</div>
        </Space>
      ),
    },
    {
      title: 'Doanh Thu',
      sorter: (a, b) => a.stats?.total_spend - b.stats?.total_spend,
      render: (record) => (
        <Space direction='vertical'>
          <div>{formatCurrency(record.stats?.total_spend)}</div>
        </Space>
      ),
    },
    {
      title: 'Gần Đây',
      sorter: (a, b) => a.stats?.recent_spend - b.stats?.recent_spend,
      render: (record) => (
        <Space direction='vertical'>
          <div>{formatCurrency(record.stats?.recent_spend)}</div>
        </Space>
      ),
    },
    {
      title: 'Đơn hàng gần đây',
      render: (record) => (
        <Space direction='vertical'>
          {record.stats?.last_order?.id && (
            <>
              <div
                onClick={() => onNavigateOrder(record.stats?.last_order?.id)}
                style={{ cursor: 'pointer' }}
              >
                {record.stats?.last_order?.id}
              </div>
              <div>{formatCurrency(record.stats?.last_order.total_amount)}</div>
              <div>{formatDate(record.stats?.last_order.create_on)}</div>
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Card style={{ width: '100%' }}>
        <Space direction='vertical' style={{ width: '100%' }}>
          <Search
            placeholder='Số điện thoại hoặc tên'
            onSearch={onSearch}
            onChange={(e) => setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
          />
        </Space>
        <Divider />
        <Row gutter={16}>
          <Col span={12}>
            <Statistic title='Tổng số khách hàng' value={data.length} />
          </Col>
          <Col span={12}>
            <Statistic
              title='Tổng số xu'
              value={_.sumBy(data, (x) => x.loyalty_point?.current ?? 0)}
              precision={0}
            />
          </Col>
        </Row>
        <Flex justify='space-between' align='center'>
          <div />
          <Button type='primary' onClick={onAddCustomer}>
            Thêm Mới
          </Button>
        </Flex>
      </Card>
      <Card style={{ width: '100%' }}>
        <Table dataSource={data} columns={columns} />
      </Card>
      <CustomerInfoPage
        id={clickPhone}
        open={showCustomerInfo}
        onClose={onCloseCustomerInfo}
        onSave={refreshList}
      />
      <CustomerInfoEdit
        open={showAddCustomer}
        onClose={onCloseAddCustomer}
        onSave={refreshList}
      />
    </Space>
  );
};

export default CustomerListDesktop;
